"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectTextColour = exports.colourMap = void 0;
var colourMap = exports.colourMap = function colourMap(colourName) {
  switch (colourName) {
    case 'White':
      return '#FFFFFF';
    case 'Light Taupe':
      return '#EEEAE4';
    case 'Neon Green':
    case 'Neon Pastel Green':
      return '#DFFF7B';
    case '10% Neon Pastel Green':
      return '#F9FFE5';
    case 'Neutral Very Light Grey':
      return '#F5F5F5';
    case 'Taupe':
      return '#D2CABC';
    case 'Heritage Green':
      return '#102B2B';
    case 'Text Black':
      return '#141414';
    default:
      return '#fff';
  }
};
var selectTextColour = exports.selectTextColour = function selectTextColour(colour) {
  switch (colour) {
    case 'Neon Green':
      return {
        textColourValue: '#dfff7b',
        textColourName: 'neon-green'
      };
    case 'Taupe':
      return {
        textColourValue: '#d2cabc',
        textColourName: 'taupe'
      };
    case 'Light Taupe':
      return {
        textColourValue: '#eeeae4',
        textColourName: 'taupe-light'
      };
    default:
      return {
        textColourValue: '#102b2b',
        textColourName: 'heritage-green'
      };
  }
};